import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { activeCurrencySelector } from '../../selectors/CurrencySelectors';
import { groupedFeesByProductLevelSelector } from '../../selectors/PricingSelectors';
import RequiredOnboardingSubtext from './RequiredOnboardingSubtext';

const RequiredOnboardingSubtextContainer = ({
  queryParamTerm,
  skuIds,
  tab,
  trackingSource,
  includesOnboardingCost = false
}) => {
  const activeCurrencyCode = useSelector(activeCurrencySelector); // Group fees by product level if possible

  const feesMap = useSelector(state => groupedFeesByProductLevelSelector(state, {
    skuIds,
    queryParamTerm
  }));
  return /*#__PURE__*/_jsx(_Fragment, {
    children: Object.keys(feesMap).map(langKey => /*#__PURE__*/_jsx(RequiredOnboardingSubtext, {
      pricingInfo: feesMap[langKey],
      currencyCode: activeCurrencyCode,
      langKey: langKey,
      tab: tab,
      trackingSource: trackingSource,
      includesOnboardingCost: includesOnboardingCost
    }, langKey))
  });
};

export default RequiredOnboardingSubtextContainer;